/*
 * 共通js
 */

jQuery(document).ready(function ($) {
  console.log(window.navigator.userAgent.toLowerCase());

  // load resize
  var resizeTimer = false;
  $(window).on("load resize", function () {
    if (resizeTimer !== false) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(function () {
      if (window.matchMedia("(min-width:769px)").matches) {
        setupPc();
      } else {
        setupSp();
      }
    }, 200);
  });

  // スクロール処理
  var scrollTimer = false;
  $(window).scroll(function () {
    // to-top表示切替
    if (scrollTimer !== false) {
      clearTimeout(scrollTimer);
    }
    scrollTimer = setTimeout(function () {
      var pos = $(window).scrollTop();
      var newsTop = 200;
      if (pos >= newsTop) {
        $("#to-top").addClass("is-show");
      } else {
        $("#to-top").removeClass("is-show");
      }
    }, 200);
  });

  // Gナビメニューにclickできる要素の追加
  $("#gnav .gmenu > .menu-item-has-children > a").append($("<span />"));
  // スクロール位置保持用
  var scrollPos;

  // topへ戻る
  $("#to-top").on("click", function () {
    $("html,body").animate({
      scrollTop: 0
    }, "slow", "swing");
    return false;
  });

  //footerメニューリンクからのスクロール処理
  var headerHeight = $("#header").outerHeight(); //fixedのヘッダーの高さを取得
  var urlHash = location.hash; //URLハッシュを取得
  var animeSpeed = 500; //スクロールのアニメーションスピード
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function () {
      var target = $(urlHash);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({
        scrollTop: position
      }, animeSpeed);
    }, 100);
  }
  $('a[href^="#"]').on({
    'click': function () {
      var href = $(this).attr("href");
      var target = $(href);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({
        scrollTop: position
      }, animeSpeed);
    }
  });

  /*
   * PCのみ設定
   */
  function setupPc() {
    console.log("is pc!");

    // 開閉ブロックは無効
    $("#sp-menu-toggle").off();
    $(".foldable-block .fold-heading").off();

    // Gナビメニューのドロップダウン
    $("#gnav .gmenu > .menu-item-has-children>a>span").off();
    $("#gnav .gmenu > .menu-item-has-children").off();
    $("#gnav .gmenu > .menu-item-has-children").on({
      mouseenter: function () {
        $(this).children(".sub-menu").addClass("open");
      },
      mouseleave: function () {
        $(this).children(".sub-menu").removeClass("open");
      },
    });
  }

  /*
   * SPのみ設定
   */
  function setupSp() {
    console.log("is sp!");

    // サブメニューのドロップダウン
    $("#gnav .gmenu > .menu-item-has-children").off();
    $("#gnav .gmenu > .menu-item-has-children>a>span").off();
    $("#gnav .gmenu > .menu-item-has-children>a>span").on("click", function () {
      var parent = $(this).parents(".menu-item-has-children");
      parent.toggleClass("open");
      parent.children(".sub-menu").slideToggle("fast");
      return false;
    });

    // メニュー選択時にメニューを閉じる
    $("#gnav .gmenu .menu-item > a").off();
    $("#gnav .gmenu .menu-item > a").on("click", function () {
      $("#sp-menu-toggle").removeClass("active");
      $("#gnav")
        .removeClass("visible")
        .addClass("close")
        .delay(700)
        .queue(function () {
          $(this).removeClass("open close").dequeue();
        });
      $("body").removeClass("fixed").css("top", "");
      return true;
    });

    // メニューの開閉
    // var scrollPos;
    $("#sp-menu-toggle").off();
    $("#sp-menu-toggle").on("click", function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $("#gnav")
          .removeClass("visible")
          .addClass("close")
          .delay(700)
          .queue(function () {
            $(this).removeClass("open close").dequeue();
          });

        // 位置固定解除
        $("body").removeClass("fixed").css("top", "");
        $("html,body").prop({
          scrollTop: scrollPos,
        });
      } else {
        $(this).addClass("active");
        $("#gnav")
          .addClass("open")
          .delay(700)
          .queue(function () {
            $(this).addClass("visible").dequeue();
          });

        // 位置固定にする
        scrollPos = $(window).scrollTop();
        $("body")
          .addClass("fixed")
          .css({
            top: "-" + scrollPos + "px",
          });
      }
      return false;
    });

    // 開閉可能ブロックの開閉
    $(".foldable-block .fold-heading").off();
    $(".foldable-block .fold-heading").on("click", function () {
      $(this)
        .toggleClass("open")
        .parent()
        .children(".fold-elements")
        .slideToggle("fast");
      return false;
    });
  }
});